'use client';

import { usePathname } from 'next/navigation';
import { AppBar } from '@/primitives';
import Navigation from './Navigation';
import HomeFloatingChrome from './HomeFloatingChrome';
import { LAYOUT_VARIANT, NAV_HEIGHT } from '@/configs/layout';
import { PUBLIC_ROUTES } from '@/configs/routes';

export default function DesktopToolbar() {
  const pathname = usePathname();
  if (pathname === PUBLIC_ROUTES.HOME) {
    return <HomeFloatingChrome />;
  }

  return (
    <AppBar
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        border: 'none',
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        height: NAV_HEIGHT,
        backgroundColor: 'background.paper',
        boxShadow: 'none',
        zIndex: 1300,
        // overflow:hidden so the inner Toolbar can slide up from below the
        // AppBar without poking out. The background/border stay static —
        // only the contents animate. See Navigation.tsx for the animation.
        overflow: 'hidden',

        '@media print': {
          display: 'none',
        },
      }}
    >
      <Navigation layout={LAYOUT_VARIANT.DESKTOP} />
    </AppBar>
  );
}
